export default __webpack_public_path__ + "static/media/VibratoryFinishImg.fe056403.jpg";